import { Box, Typography, Popover, ClickAwayListener } from '@mui/material';
import { Chip } from '../../../../../lib/components';
import { ArrowDownIcon } from '../../../../../lib/icons';
import { EmployeeListItem } from '@pxtra-client-lib-legacy/gen';
import { CellContext } from '@tanstack/react-table';
import { useState } from 'react';

export function GroupsCell({
  info
}: Readonly<{ info: CellContext<EmployeeListItem, EmployeeListItem['member_groups']> }>) {
  const groups = info.getValue();
  const isEmpty = groups?.length === 0;
  const hasMultipleGroups = groups?.length && groups.length > 1;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (hasMultipleGroups) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  let name = groups?.[0]?.name;
  if (groups?.length && groups.length > 1) {
    name = name?.length && name.length > 8 ? name.slice(0, 7) + '…' : name;
    name += groups.length > 1 ? ' + ' + (groups.length - 1) : '';
  }

  return (
    <Box sx={{ display: 'flex', gap: '.25rem' }}>
      {isEmpty ? (
        <Typography sx={{ opacity: '.3' }}>-</Typography>
      ) : (
        <>
          <Chip
            variant="outlined"
            color="neutral"
            label={name}
            clickable={Boolean(hasMultipleGroups)}
            disabled={false}
            onClick={handleClick}
            onDelete={handleClick}
            deleteIcon={hasMultipleGroups ? <ArrowDownIcon /> : <></>}
            sx={{ maxWidth: '135px', opacity: 1 }}
          />
          <Popover
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            BackdropProps={{
              invisible: true,
              style: { backgroundColor: 'transparent', opacity: '0' }
            }}
            PaperProps={{
              className: 'shadow-500'
            }}
          >
            <ClickAwayListener onClickAway={handleClose}>
              <Box sx={{ p: 2, minWidth: '200px' }}>
                {groups?.map((group) => (
                  <Typography key={group.id} variant="body2" sx={{ py: 0.5 }}>
                    {group.name}
                  </Typography>
                ))}
              </Box>
            </ClickAwayListener>
          </Popover>
        </>
      )}
    </Box>
  );
}
